module.exports = __webpack_public_path__ + "static/media/44.ecbf5036.mp3";